import { el } from './dom.js';
import { openModal } from './modal.js';
import { mountContactForm } from './contact-form.js';

const LINKS: [string, string][] = [
  ['/nasil-kaydederim.html', 'Belgemi nasıl kaydederim?'],
  ['/deneyin.html', 'Hesapsız deneyin'],
  ['/kanit.html', 'Verileriniz nereye gidiyor?'],
  ['/aydinlatma.html', 'Aydınlatma metni'],
  ['/acik-riza.html', 'Açık rıza metni'],
  ['/kullanim-sartlari.html', 'Kullanım şartları'],
  ['/kalibrasyon.html', 'Cihaz testi'],
];

/** Sayfanın altına ortak footer'ı ekler; her sayfadan bir kez çağrılır. */
export function mountFooter(): void {
  if (document.querySelector('footer.site')) return;
  const contact = el('button', { type: 'button', class: 'secondary', id: 'contactOpen' }, ['İletişim']);
  contact.addEventListener('click', async () => {
    const m = openModal({ title: 'İletişim' });
    // Oturum bilgisi (ad, e-posta) formu doldurur; auth istemcisi yalnızca pencere açılınca yüklenir,
    // hukuk metni gibi statik sayfalar peşinen taşımasın.
    const { currentSession } = await import('./nav.js');
    mountContactForm(m.body, { session: await currentSession() });
  });
  document.body.append(el('footer', { class: 'site' }, [
    el('div', { class: 'footer-inner' }, [
      el('nav', { class: 'footer-links' }, LINKS.map(([href, text]) => el('a', { href }, [text]))),
      contact,
      el('p', { class: 'muted' }, [`© ${new Date().getFullYear()} akrababul`]),
    ]),
  ]));
}

mountFooter();
